module.exports = __webpack_public_path__ + "static/media/facebookLogo.0a7994c8.svg";